﻿import { GuiDetailGeneric } from "../../GuiDetailGeneric";

export class GuiDetailKostenart extends GuiDetailGeneric {
    constructor() {
        super("Kostenart");
    }
}


